<template>
  <v-container fluid>
    <v-row>
      <!-- name/title card -->
      <v-col>
        <v-card>
          <v-card-title class="headline font-weight-medium">
            Compliance Settings
            <v-spacer />
          </v-card-title>
          <v-card-subtitle class="title font-weight-regular">{{ getOrg }}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <!-- Datasets  -->
    <v-row>
      <v-col>
        <v-card :loading="loading">
          <v-card-title>
            Data Sets
            <v-spacer />
            <v-btn icon @click="onEditSourcesClick()" color="primary">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle>Configure which sanction lists to include in initial and ongoing case screening.</v-card-subtitle>
          <v-card-text>
            <template
              v-if="
                getAccount.accountSettings &&
                getAccount.accountSettings.lists &&
                getAccount.accountSettings.lists.length > 0
              ">
              <v-chip class="ma-1" v-for="source in getAccount.accountSettings.lists" :key="source" small>
                {{ source }}
              </v-chip>
            </template>
            <template v-else
              ><i>No sanction sources set. Defaulting to US Treasury Department.</i></template
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <EditComplianceSources
      :visible="isEditSourcesVisible"
      :account="this.getAccount"
      v-on:onCancelled="onEditSourcesCancelled" />
  </v-container>
</template>

<script>
import EditComplianceSources from "../../modals/account settings/EditComplianceSources.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ComplianceSettings",
  components: { EditComplianceSources },
  data() {
    return {
      loading: true,
      isEditSourcesVisible: false,
    };
  },
  methods: {
    ...mapActions(["fetchAccount", "setGlobalAlert"]),
    onEditSourcesClick() {
      this.isEditSourcesVisible = true;
    },
    onEditSourcesCancelled() {
      this.isEditSourcesVisible = false;
    },
  },
  computed: {
    ...mapGetters(["getAccount", "getOrg"]),
  },
  created() {
    this.fetchAccount()
      .catch(() => {
        this.setGlobalAlert({
          alert: true,
          color: "red",
          alertTitle: "There's been a problem",
          alertMessage: "Unable to retrieve account information. Please try again shortly. ",
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
